import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [
        "openArrow", "closeArrow", "loading", "detailList", "row"
    ]

    static DATA_LOADED = false;
    static OPEN = false;

    connect()
    {
        this.SEQ_NUM_BIG = this.rowTarget.dataset["seq_num"];
        this.SERVER_NUM = this.rowTarget.dataset["server"];
        this.SITE_NUM = this.rowTarget.dataset["site_num"];

        this.rowTarget.addEventListener("click", (e) =>
        {
            if(!this.loadingTarget.classList.contains("hidden")) return;

            if(this.DATA_LOADED)
            {
                if(!this.OPEN)
                {
                    this.openArrowTarget.classList.add("hidden");
                    this.closeArrowTarget.classList.remove("hidden");
                    this.detailListTarget.classList.remove("hidden");

                    this.OPEN = true;
                }
                else
                {
                    this.openArrowTarget.classList.remove("hidden");
                    this.closeArrowTarget.classList.add("hidden");
                    this.detailListTarget.classList.add("hidden");

                    this.OPEN = false;
                }
            }
            else
            {
                this.openArrowTarget.classList.add("hidden");
                this.loadingTarget.classList.remove("hidden");

                fetch(window.App.prefixedUrl(`/sites/${this.SITE_NUM}/changes/detail/${this.SERVER_NUM}/${this.SEQ_NUM_BIG}/list`))
                .then(data => data.json())
                .then(data =>
                {
                    let details = data.map(detail => this.createDetailElement(detail));
                    this.detailListTarget.innerHTML = "";

                    this.detailListTarget.append(...details);
                    this.loadingTarget.classList.add("hidden");
                    this.closeArrowTarget.classList.remove("hidden");

                    this.detailListTarget.classList.remove("hidden");

                    this.DATA_LOADED = true;
                    this.OPEN = true;
                })
                .catch((error) =>
                {
                    console.error(error);
                    this.loadingTarget.classList.add("hidden");
                    this.openArrowTarget.classList.remove("hidden");

                    const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred while loading transaction details, please try again later." })
                    window.dispatchEvent(errorEvent);
                })
            }
        })

    }

    createDetailElement(data)
    {
        if (data.new_string) data.new_string = data.new_string.trim();
        if (data.old_string) data.old_string = data.old_string.trim();
        

        let div = document.createElement("div");
        div.innerHTML = `
         <div class="detail">
            <div class="flex flex-col">
                <span>Column Name</span>
                <span>${data.column_name}</span>
            </div>
            <div class="flex flex-col">
                <span>New Value</span>
                <span class="${data.new_string ? "" : "text-muted italic"}">${data.new_string == "" ? "null" : data.new_string}</span>
            </div>
            <div class="flex flex-col">
                <span>Old Value</span>
                <span class="${data.old_string ? "" : "text-muted italic"}">${data.old_string == "" ? "null" : data.old_string}</span>
            </div>
        </div>
        `;
        return div.firstElementChild;
    }
}